import { Injectable, OnInit, Injector } from '@angular/core';
import { CartaoDeprecated } from 'app/resources/classes/cartaoDeprecated';
import { HttpService } from 'app/resources/services/http.service';
import { EnderecoResidencial } from 'app/resources/classes/enderecoDeprecated';
import { TelefoneCelular } from 'app/resources/classes/telefone-celular';
import { TelefoneComercial } from 'app/resources/classes/telefone-comercial';
import { TelefoneResidencial } from 'app/resources/classes/telefone-residencial';

@Injectable()
export class CartaoService {
  public cartao: CartaoDeprecated;
  private completos: boolean;
  public documentoTipo: string;
  public cartaoCurrent: any;

  constructor(public http: HttpService) { }

  public setCartao(cartao: any) {
    this.cartao = this.verificaNulos(cartao);
    this.setDocumentoTipo(this.cartao.documento);
    this.recarregar();
  }

  public verificaNulos(cartao) {
    if (cartao.enderecoResidencial == undefined) {
      cartao.enderecoResidencial = new EnderecoResidencial({
        bairro: undefined,
        cep: undefined,
        cidade: undefined,
        logradouro: undefined,
        numero: undefined,
        uf: undefined,
        complemento: undefined
      });
    }
    if (cartao.telefoneCelular == undefined) {
      cartao.telefoneCelular = new TelefoneCelular({ numero: undefined, ddd: undefined });
    }
    if (cartao.telefoneComercial == undefined) {
      cartao.telefoneComercial = new TelefoneComercial({ numero: undefined, ddd: undefined });
    }
    if (cartao.telefoneResidencial == undefined) {
      cartao.telefoneResidencial = new TelefoneResidencial({ numero: undefined, ddd: undefined });
    }

    return cartao;
  }

  public recarregar() {
    this.http.pathRest().get('cartao/current/', true)
      .subscribe(
      sucesso => {
        this.cartaoCurrent = this.verificaNulos(sucesso.json());
        this.revalidar();
      }, erro => {

      }
      );
    return this;

  }

  public revalidar() {

    this.http.pathRest().get('cartao/current/dadosPessoaisIsNull/', true)
      .subscribe(
      sucesso => {
        this.completos = !sucesso.json();
      },
      erro => {
        this.completos = false;
      });
  }

  public isPessoaFisica(documento) {
    return documento && documento.length === 11;
  }

  public setDocumentoTipo(documento) {
    if (this.isPessoaFisica(documento)) {
      this.documentoTipo = 'CPF';
    } else {
      this.documentoTipo = 'CNPJ';
    };
  }

  public isCompletos() {
    return this.completos;
  }


}



// WEBPACK FOOTER //
// ./src/app/resources/services/cartao.service.ts